/**
 * Drop down Helper class
 */
export default class Dropdown {
    /**
     * @requires Markup for drop downs LM2 style.
     * @requires Table Component class
     * @requires Routes Helper class
     * @requires Repository class
     * @requires JSon file with event properties - see discount tool
     * @requires Static table id
     * @requires Static dropdown id - see discount tool.
     * @param {*} params object with required objects and properties
     */
    constructor(params) {
        this.table = params.table;
        this.tableProps = params.tableProps;
        this.routes = params.routes;
        this.repository = params.repository;
        this.eventProps = params.eventProps;
        this.tableId = params.tableId;
        this.setListenerData(params.initElement);
    }

    /**
     * @description Init select element event listeners
     * Applying the Eventlistener properties/rules from json file.
     * @requires json object with properties/settings
     * @param {string} elementName element id/
     * @returns void
     */
    setListenerData(elementName) {
        for (let item in this.eventProps) {
            if (this.eventProps[item].element === elementName) {
                this.addListener({
                    element: `${elementName} .dropdown`,
                    targetElement: this.eventProps[item].targetElement,
                    key: item,
                    scope: this,
                });
            }
        }
    }

    /**
     * @description Add Event listerner to dropdown
     * @param {Object} params object with properties and data
     * @returns void
     */
    addListener(params) {
        for (let item of document.querySelectorAll(`#${params.element} a`)) {
            let listener = function (event) {
                params.scope.getDropDownDataAsync(event, {
                    element: `#${params.element} .dropdown`,
                    targetElement: params.targetElement,
                    key: params.key,
                    scope: params.scope,
                });

                params.scope.handleDropDownOnClick({ event: event, element: params.element });
            };
            item.addEventListener('click', listener, false);
        }
    }

    /**
     * @desciption Replacing the LM2 dropdown element logic
     * Handling click events on dropdown list
     * @param {Object} params object with properties
     * @returns void
     */
    handleDropDownOnClick(params) {
        const parentItem = document.querySelector(`#${params.element}`).parentNode;
        this.resetDropDowns(`${params.element}`);

        for (let item of parentItem.querySelectorAll(`.dropdown li`)) {
            item.classList.remove('selected');
        }

        parentItem
            .querySelector(`input`)
            .setAttribute('value', params.event.target.getAttribute('data-id'));
        parentItem.querySelector(`.dropdown`).setAttribute('style', 'display:none;');
        parentItem.querySelector(`.placeholder`).textContent = params.event.target.innerText;

        params.event.target.parentNode.classList.add('selected');
        document.querySelector(`.lm__form-dropdown .error`).classList.add('hidden');
        this.table.removeAllChildNodes(document.querySelector(`#${this.tableId}`));
    }

    /**
     * @description Reset and set init value.
     * @param {Object} element element id and css class
     * @requires json object with properties
     * @returns void
     */
    resetDropDowns(element) {
        for (let item in this.eventProps) {
            if (
                element.replace(' .dropdown', '').trim() === this.eventProps[item].element &&
                this.eventProps[item].reset !== null
            ) {
                for (let resetItem of this.eventProps[item].reset) {
                    document.querySelector(`#${resetItem} a`).textContent = document
                        .querySelector(`#${resetItem} a`)
                        .getAttribute('data-placeholder');
                    document.querySelector(`#${resetItem}`).classList.add('disabled');
                }
            }
        }
    }

    /**
     * @description Get Data from back end api
     * @param {Object} evt event
     * @param {Object} params key and scope
     * @requires module:routes routes helper class
     * @requires module:repository repository class
     * @requires json object with properties
     * @returns void
     */
    getDropDownDataAsync = async (evt, params) => {
        const eventId = evt.target.getAttribute('data-id');
        const response = await params.scope.repository.fetchDataAsync({
            route: params.scope.routes.setRouteParameters(
                `${params.scope.eventProps[params.key].route}${eventId}`,
                null
            ),
        });

        if (response && params.scope.eventProps[params.key].targetElementType === 'dropdown') {
            params.scope.setDropDownData(response, params);
        } else {
            params.scope.addTable(response);
        }
    };

    /**
     * @description Set DropDown data
     * @param {Object} response data from back end api
     * @param {Object} params key and scope
     * @returns void
     */
    setDropDownData(response, params) {
        const elementName = params.targetElement;
        const dropDown = document.querySelector(`#${elementName} .dropdown`);

        dropDown.innerHTML = '';

        try {
            for (let item of response.body) {
                let listItem = document.createElement('li');
                let listHref = document.createElement('a');

                listItem.setAttribute('data-value', item.Id ? item.Id : '');
                listHref.setAttribute('data-id', item.Id ? item.Id : '');
                listHref.setAttribute('href', 'javascript:void(0)');
                listHref.textContent = item.Name ? item.Name : '';

                listItem.appendChild(listHref);
                dropDown.appendChild(listItem);

                document.querySelector(`#${elementName}`).classList.remove('disabled');
            }
        } catch (e) {
            console.log(e);
            return false;
        }

        this.setListenerData(elementName);
    }

    /**
     * @description Add Table and Generate table-data
     * @param {Object} response data from back end api
     * @requires module:Table
     * @returns void || boolean
     */
    addTable(response) {
        if (!response.body) {
            return false;
        }

        if (!response.responseValidate) {
            this.renderErrorMessage(response.body);
            return false;
        }

        try {
            this.table.addTableHead(`#${this.tableId}`, response.body, this.tableProps);
            this.table.addTableBody(`#${this.tableId}`, response.body, this.tableProps);
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Render Error message when Id is null and there is no data.
     * @param {Object} response
     * @returns void 
     */
    renderErrorMessage(response) {
        document.querySelector('.lm__form-dropdown .error').classList.remove('hidden');
        document.querySelector('.lm__form-dropdown .error').innerText = response;
    }
}
